module.exports = __webpack_public_path__ + "static/default-d98441c3b14c11b59cc49da1273dc8b8.svg";